import React from 'react';
import { Container } from './styles';

const ContainerSubtitle = ({ children }) => (
  <Container> | {children}</Container>
);

export default ContainerSubtitle;
